import * as React from 'react';
import { observer } from 'mobx-react';
import { FormField } from '../form-field';
import { Textbox } from '../../primitives/textbox';
import { FieldValidationMessage } from '../form-control/form-control-validation-error';
import { TextMaskInput } from '../text-mask-input';
import { FormControlLabel } from '../../primitives/label';
import { StandardTooltip, TooltipPlacement } from '../tooltip/tooltip';
import { Text } from '../../components/text';

import * as styles from './cvv-input.less';

export interface ICvvInputProps {
	value: FormField<string>;
	formControlId: string;
	acceptanceTestTargetId: string;
}

const mask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

@observer
export class CvvInput extends React.Component<ICvvInputProps, {}> {
	render() {
		const { value, formControlId, acceptanceTestTargetId } = this.props;
		const additionalClassNames = value.hasValidationError ? 'form-control-invalid' : '';

		const cvvContent = <Text>Your card's CVV is a 3 or 4 digit number, usually on the back next to your signature</Text>;

		return (
			<div className="form-control-container">
				<div className={styles.labelContainer}>
					<FormControlLabel className={styles.label} formControlId={formControlId}>CVV</FormControlLabel>
					<StandardTooltip
						buttonClassName={styles.tooltip}
						placement={TooltipPlacement.Right}
						mobileHeader="CVV"
						content={cvvContent}
						tooltipContentId="cvvTooltip"
					>
					</StandardTooltip>
				</div>
				<TextMaskInput mask={mask}>
					<Textbox
						value={value.value}
						formControlId={formControlId}
						onChange={value.updateValue}
						onBlur={value.revalidate}
						numericKeyboard
						dataFieldInvalid={value.hasValidationError}
						additionalClassNames={additionalClassNames}
						acceptanceTestTargetId={acceptanceTestTargetId}
						autoComplete="off"
						ariaDescribedBy="cvvTooltip"
					/>
				</TextMaskInput>
				<FieldValidationMessage errorMessage={value.validationError} />
			</div>
		);
	}
}
